import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);
import PortfolioUploadView from '@frontend/ui/views/portfolio/main.vue';
import FundSearchView from '@frontend/ui/views/FundSearch.vue';
import GeneratePortfolioView from '@frontend/ui/views/portfolio-generator/GeneratePortfolioView.vue';

const routes = [
];

routes.push({
  name: 'portfolio-upload', path: '/visitor/portfolio-upload',
  component: PortfolioUploadView,
});
routes.push({
  name: 'fund-search', path: '/visitor/fund-search',
  component: FundSearchView,
});
routes.push({
  name: 'generate-portfolio', path: '/visitor/generate-portfolio',
  component: GeneratePortfolioView,
});
routes.push({
  name: 'investment-search', path: '/visitor/investment-search',
  component: GeneratePortfolioView,
});


const router = new VueRouter({
  routes: routes,
  mode: 'history',
  base: 'ui/',
});

export default router;
